import _ from 'lodash';
import BaseStore from 'vendor/cnpm/fluxible.v0-4/addons/BaseStore';

const SERIALIZED_PROPS: Array<keyof DehydratedState> = ['unsubscribeStatus', 'invalidTokenError'];

type DehydratedState = {
  unsubscribeStatus: any;
  invalidTokenError?: string;
};

class UnsubscribeStore extends BaseStore {
  declare unsubscribeStatus: any;

  declare invalidTokenError?: string;

  declare emitChange: () => void;

  static storeName = 'UnsubscribeStore';

  static handlers = {
    UPDATE_STATUS: 'onUpdateStatus',
    RECEIVED_ERROR: 'onReceivedError',
  };

  onUpdateStatus(unsubscribeStatus: any): void {
    this.unsubscribeStatus = unsubscribeStatus;
    this.emitChange();
  }

  onReceivedError(invalidTokenError: string): void {
    this.invalidTokenError = invalidTokenError;
    this.emitChange();
  }

  dehydrate(): DehydratedState {
    return _.pick(this, ...SERIALIZED_PROPS);
  }

  rehydrate(state: DehydratedState): void {
    Object.assign(this, _.pick(state, ...SERIALIZED_PROPS));
  }

  hasLoaded(): boolean {
    return !!this.unsubscribeStatus || !!this.invalidTokenError;
  }

  getUnsubscribeStatus(): any {
    return this.unsubscribeStatus;
  }

  getInvalidTokenError(): string | undefined {
    return this.invalidTokenError;
  }
}

export default UnsubscribeStore;
